
import { Route, Switch, RouteComponentProps } from 'react-router-dom'
import {Android} from './Android'
import {Ios} from './Ios'

type TParams = { id: string };

export function SdkVersion(props: RouteComponentProps<TParams>) {
    const withTitle = (Comp: any): React.FunctionComponent => 
        (sprops: any) => {
            return <Comp {...props} {...sprops} />
        }

    return (
        <div>
            <Switch>
                <Route path={'/sdk/android'} component={withTitle(Android)}  />
                <Route path={'/sdk/ios'} component={withTitle(Ios)}  />
            </Switch>
        </div>
    );
}       